import { usePermissions, UserPermission, WriteOn, ReadOn, DeleteOn } from 'modules/permissions';
import React, { useCallback } from 'react';
import { ObservationStatusEnum } from 'shared/enums/ObservationStatus.enum';
import { StyledPanelGrid, StyledPanelRow, StyledPanelColumn, StyledContainer } from 'shared/styled/panel.stayled';
import { Issue } from '../../../queries/view-issue.queries.types';
import { ObservationFileEntity } from 'shared/types/file/ObservationFileEntity';
import { IRemoveFiles } from 'shared/utils/files/types/IRemoveFiles';
import AmendObservationPhotos from 'components/ObservationPhoto/components/AmendObservationPhotos';
import IssueReporter from '../../IssueReporter';
import IssueCategorisation from 'components/IssueCategorisation';
import IssueDetails from 'components/IssueDetails/components/IssueDetails';

interface AmendIssueForm {
   issue: Issue | undefined;
   removeFiles: IRemoveFiles<ObservationFileEntity>;
   files: ObservationFileEntity[];
}

const AmendIssueForm = ({ issue, removeFiles, files }: AmendIssueForm) => {
   const { hasPermission } = usePermissions();

   const canEditIssue = useCallback((): boolean => {
      return (
         issue?.observationStatus === ObservationStatusEnum.Open &&
         hasPermission(WriteOn(UserPermission.ExistingObservation))
      );
   }, [issue, hasPermission]);

   const canDeletePhoto = useCallback((): boolean => {
      return (
         issue?.observationStatus === ObservationStatusEnum.Open && hasPermission(DeleteOn(UserPermission.ImageFile))
      );
   }, [issue, hasPermission]);

   const canEditReporter = useCallback((): boolean => {
      return (
         issue?.observationStatus === ObservationStatusEnum.Open &&
         hasPermission(WriteOn(UserPermission.ObservationReporter))
      );
   }, [issue, hasPermission]);

   return (
      <React.Fragment>
         <StyledContainer>
            <StyledPanelGrid fluid>
               <StyledPanelRow>
                  <StyledPanelColumn md={12} lg={4} xl={4}>
                     <IssueCategorisation readOnly={!canEditIssue()} />
                  </StyledPanelColumn>
                  <StyledPanelColumn md={12} lg={4} xl={4}>
                     <IssueDetails readOnly={!canEditIssue()} />
                     <AmendObservationPhotos
                        observationType='Issue'
                        uniqueRecordId={issue?.uniqueRecordId}
                        removeFiles={removeFiles}
                        files={files}
                        canDelete={canDeletePhoto()}
                        useEnglish
                     />
                  </StyledPanelColumn>
                  <StyledPanelColumn md={12} lg={4} xl={4}>
                     <IssueReporter isReadOnly={true} reporterReadOnly={!canEditReporter()} />
                  </StyledPanelColumn>
               </StyledPanelRow>
            </StyledPanelGrid>
         </StyledContainer>
      </React.Fragment>
   );
};

export default AmendIssueForm;
